import React from "react";
import { FallbackProps } from "react-error-boundary";
import { Container, Paper, Typography, Stack, Button } from "@mui/material";
import { TYPOGRAPHY_STYLES } from "../../styles/typographyStyles";

export const AppErrorFallback: React.FC<FallbackProps> = () => {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Paper sx={{ p: 4 }}>
                <Typography
                    sx={{
                        ...TYPOGRAPHY_STYLES.rubikLarge,
                        fontSize: "20px",
                        fontWeight: 600,
                    }}
                    gutterBottom
                >
                    Ocurrió un error inesperado
                </Typography>

                <Typography
                    sx={{
                        ...TYPOGRAPHY_STYLES.rubikMedium,
                        color: "#666",
                        mb: 3,
                    }}
                >
                    Se registró este problema a nuestro equipo y ya está trabajando para solucionarlo.
                </Typography>

                <Stack
                    direction="row"
                    justifyContent="center"
                >
                    <Button
                        variant="text"
                        sx={{
                            width: { xs: "100%", sm: "fit-content" },
                            alignSelf: "flex-start",
                            backgroundColor: "#000",
                            color: "#fff !important",
                            fontFamily: "Rubik",
                            fontWeight: 500,
                            textTransform: "none",
                            py: 1.5,
                            px: 4,
                            "&:hover": { backgroundColor: "#333" },
                        }}
                        onClick={() => (window.location.href = "/")}
                    >
                        Volver al inicio
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
};














